import { AUTH_API_HOST } from "@/api/apis";

export class AuthUtils {
  public static getLoginUrl(returnPath?: string): string {
    return AuthUtils.buildAuthUrl("login", returnPath);
  }

  /**
   * 계정 만들기 화면. auth 의 `/signup` 도 `/login` 과 같은 `success-url` 계약을 따르므로
   * (가입 체인 signup → verify-email → greetings 통과 후 복귀) 같은 방식으로 만든다.
   * 가입 유도 CTA(신규 가입 쿠폰 팝업 등)는 로그인이 아니라 이쪽으로 보낼 것.
   */
  public static getSignUpUrl(returnPath?: string): string {
    return AuthUtils.buildAuthUrl("signup", returnPath);
  }

  /**
   * @param returnPath 인증 후 돌아올 **사이트 내부 경로**. 생략하거나 내부 경로가 아니면
   *   기존 동작대로 현재 페이지로 복귀한다.
   *
   *   ⚠️ 종전 주석은 *"`encodeURI` 로만 감싸므로 파라미터는 1개까지만 넣을 것"* 이었다.
   *   그 제약은 **없어졌다** — `encodeURIComponent` 로 바꿔 파라미터가 여러 개여도 온전히
   *   왕복한다(#5560 · 근거·실측표는 `generateLoginLink` 의 KDoc). 되돌리면
   *   `__tests__/api/auth-link-encoding.test.ts` 가 발화한다.
   */
  private static buildAuthUrl(
    authPath: "login" | "signup",
    returnPath?: string,
  ): string {
    if (typeof window !== "undefined") {
      const { protocol, host, pathname, search } = window.location;
      const target =
        AuthUtils.toInternalPath(returnPath) ?? `${pathname}${search}`;
      const redirectUrl = `${protocol}//${host}${target}`;
      return `${AUTH_API_HOST}/${authPath}?success-url=${encodeURIComponent(redirectUrl)}`;
    } else {
      return `${AUTH_API_HOST}/${authPath}`;
    }
  }

  /**
   * 내부 경로만 통과시킨다. 지금 호출부는 하드코딩 리터럴뿐이지만, 나중에 사용자 입력
   * (쿼리스트링 등)이 흘러들어오면 오픈 리다이렉트가 되므로 입구에서 막는다.
   * 차단 예: `//evil.com`(프로토콜 상대), `/\evil.com`(브라우저가 `//` 로 해석),
   * `@evil.com`(`https://host@evil.com` userinfo 트릭), `https://evil.com`.
   */
  private static toInternalPath(path?: string): string | null {
    if (!path) return null;
    return /^\/(?![/\\])/.test(path) ? path : null;
  }

  public static getLogoutUrl(): string {
    if (typeof window !== "undefined") {
      const { protocol, host, pathname, search } = window.location;
      const redirectUrl = `${protocol}//${host}${pathname}${search}`;
      return `${AUTH_API_HOST}/logout?redirect-url=${encodeURIComponent(redirectUrl)}`;
    } else {
      return `${AUTH_API_HOST}/logout`;
    }
  }
}
